<template>
  <div id="modal-table">
    <b-table
      class="add-document-table"
      :items="orders.test_list"
      :fields="fields"
      striped
      bordered
      foot-clone
    >
      <template slot="date">
        {{ (orders.created_at) }}
      </template>
      <template
        slot="ln"
        slot-scope="data"
      >
        <a
          @click="
                        goResultDetail(
                            data.item.id,
                            data.item.animal_id,
                            orders.hospital_id,
                            true
                        )
                    "
        >
          <u>{{ data.item.ln }}</u>
        </a>
      </template>
      <template
        slot="patient"
        slot-scope="data"
      >
        {{ data.item.patient }}
      </template>
      <template
        slot="spp"
        slot-scope="data"
      >
        {{ data.item.spp }}
      </template>
      <template
        slot="test"
        slot-scope="data"
      >
        {{ data.item.test_item }}
      </template>
      <template
        slot="price"
        slot-scope="data"
      >
        {{ data.item.price }}
      </template>
      <template
        slot="quantity"
        slot-scope="data"
      >
        {{ data.item.quantity }}
      </template>
      <template
        slot="amount"
        slot-scope="data"
      >
        {{ data.item.total_price }}
      </template>
      <template
        slot="approver"
        slot-scope="data"
      >
        {{ data.item.approver.name }}
      </template>
      <template slot="FOOT_date">
        <p />
      </template>
      <template slot="FOOT_ln">
        <p />
      </template>
      <template slot="FOOT_patient">
        <p />
      </template>
      <template slot="FOOT_spp">
        <p />
      </template>
      <template slot="FOOT_test">
        <p />
      </template>
      <template slot="FOOT_price">
        <p />
      </template>
      <template slot="FOOT_quantity">
        <strong>{{ totalQuantity }}</strong>
      </template>
      <template slot="FOOT_amount">
        <strong>{{ totalAmount }}</strong>
      </template>
      <template slot="FOOT_approver">
        <p />
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "TestOrdersTableComponent",
  props: {
    orders: {
      type: Object
    }
  },
  data() {
    return {
      fields: {
        date: {
          label: "วันที่สั่งตรวจ"
        },
        ln: {
          label: "LN"
        },
        patient: {
          label: "PATIENT"
        },
        spp: {
          label: "SPP"
        },
        test: {
          label: "รายการตรวจ"
        },
        price: {
          label: "ราคาต่อหน่วย"
        },
        quantity: {
          label: "จำนวน"
        },
        amount: {
          label: "ราคารวม"
        },
        approver: {
          label: "ผู้อนุมัติ"
        }
      }
    };
  },
  computed: {
    totalAmount() {
      let total = 0;
      this.orders.test_list.forEach(order => {
        total += +order.total_price;
      });
      return total;
    },
    totalQuantity() {
      let total = 0;
      this.orders.test_list.forEach(order => {
        total += +order.quantity;
      });
      return total;
    }
  },
  mounted() {
    // console.log(this.orders);
  },
  methods: {
    splitDate(val) {
      return val.date.split(" ")[0];
    }
  }
};
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
